import { css } from 'styled-components';
import { responsiveProperty } from './responsiveProperty.js';

var paddingPropsNames = ['p', 'pt', 'pr', 'pb', 'pl'];
var paddingProps = css(["", ";", ";", ";", ";", ";"], function (props) {
  return props.p && responsiveProperty('padding', props.p);
}, function (props) {
  return props.pt && responsiveProperty('paddingTop', props.pt);
}, function (props) {
  return props.pr && responsiveProperty('paddingRight', props.pr);
}, function (props) {
  return props.pb && responsiveProperty('paddingBottom', props.pb);
}, function (props) {
  return props.pl && responsiveProperty('paddingLeft', props.pl);
});

export { paddingProps, paddingPropsNames };
